module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-vehicle-hardware-reveal-create"
  }, [_c('modal-reveal', {
    ref: "modalAddVehicleHardware",
    attrs: {
      "sizing": "small"
    }
  }, [_c('button', {
    staticClass: "button small",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Add Vehicle Hardware")]), _c('h2', [_vm._v("Add new Vehicle hardware")]), _c('label', [_vm._v("Vehicle V" + _vm._s(_vm.item.id) + " " + _vm._s(_vm.item.brand) + " " + _vm._s(_vm.item.model))]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Manager"), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.manager),
      expression: "manager"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.manager = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.managers), function(manager, index) {
    return _c('option', [_vm._v(_vm._s(index))])
  }), 0)])]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Serial"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.body.serial),
      expression: "body.serial"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.body.serial)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.body, "serial", $event.target.value)
      }
    }
  })])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Extra")]), _c('array-edit', {
    attrs: {
      "values": _vm.body.extra
    }
  }), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.addHardware
    }
  }, [_vm._v("Add Hardware")])], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2642ae57!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/reveal/VehicleHardwareRevealCreate.vue
// module id = 2349
// module chunks = 1